import { IntlShape } from 'react-intl'
import { formatCurrency } from 'shared/components/FormattedCurrency/formatCurrency'

type GetDisplayValueParams = {
  intl: IntlShape
  value?: string | number | null
  isFiat?: boolean
  withManualCryptoCurrency?: boolean
  currencyCode?: string | null
  showNullAsZero?: boolean
}

export const getDisplayValue = ({
  intl,
  value,
  isFiat,
  currencyCode,
  withManualCryptoCurrency,
  showNullAsZero,
}: GetDisplayValueParams) => {
  if (!value && !showNullAsZero) {
    return null
  }

  const processableValue = value == null ? 0 : value
  const displayCurrency = !withManualCryptoCurrency && currencyCode ? currencyCode : undefined

  const formattedValue = currencyCode
    ? formatCurrency(intl.locale, { value: processableValue, currency: displayCurrency, full: true })
    : processableValue

  if (isFiat) {
    return `≈${formattedValue}`
  }

  return formattedValue.toString()
}

export const checkLongDisplay = (amountValue: string | null, feeValue: string | null) => {
  if (amountValue && amountValue.length > 8) {
    return true
  }

  if (feeValue && feeValue.length > 10) {
    return true
  }

  return false
}
